<template>
  <header v-if="title || description" :class="cn('flex flex-col gap-2', props.class)">
    <UiSkeleton v-if="title" :loading="isLoading" :classes="{ line: 'h-8 w-64' }">
      <span class="text-2.5xl/8 font-semibold" v-html-format="title" />
    </UiSkeleton>

    <UiSkeleton v-if="description" :loading="isLoading" :classes="{ line: 'h-4 w-48' }">
      <span class="font-light text-neutral-700" v-html-format="description" />
    </UiSkeleton>
  </header>
</template>

<script setup lang="ts">
const props = defineProps<{
  class?: ClassValue
  title?: string
  description?: string
  isLoading?: boolean
}>()
</script>

<style lang="scss" scoped>
:deep(strong) {
  @apply text-risk5;
}
</style>
